import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./shop-by-shape-thumbnail.module.css";
export const ShopByShapeThumbnail = ({ title , href , image , alt , handleTrackEvent  })=>{
    const handleLinkTrackingEvent = ()=>{
        handleTrackEvent();
    };
    return /*#__PURE__*/ _jsxs("a", {
        className: styles.container,
        href: href,
        onClick: handleLinkTrackingEvent,
        children: [
            /*#__PURE__*/ _jsx("div", {
                "aria-hidden": "true",
                title: title,
                children: /*#__PURE__*/ _jsx("img", {
                    src: image,
                    alt: alt
                })
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: styles.text,
                children: title
            })
        ]
    });
};
